import LibraryManager from './LibraryManager';
import { adminApi } from '../../lib/api';
import { SafetyFieldset } from './SafetyFieldset';

const CATEGORIES = [
  'person_role', 'place_type', 'organisation_type',
  'theme', 'concern', 'statutory', 'event', 'document', 'other',
];

const AdminLibraryTags = () => (
  <LibraryManager
    title="Library tags"
    description="Controlled tag vocabulary used by the AI for themes, concerns, statutory references, events and roles. Entity tags (people, places) are encrypted per user and never appear here."
    testIdPrefix="library-tags"
    categories={CATEGORIES}
    api={{
      list: (params) => adminApi.listLibraryTags(params),
      create: (d) => adminApi.createLibraryTag(d),
      update: (id, d) => adminApi.updateLibraryTag(id, d),
      delete: (id) => adminApi.deleteLibraryTag(id),
      approve: (id, d) => adminApi.approveLibraryTag(id, d),
      reject: (id) => adminApi.rejectLibraryTag(id),
    }}
    labels={{
      singular: 'tag',
      plural: 'tags',
      name: 'Name (lowercase)',
      search: 'Search by name, synonym or description…',
    }}
    nameTransform={(s) => (s || '').toLowerCase()}
    showSynonyms
    extraFields={[
      { key: 'display_name', label: 'Display name (shown to users)', type: 'text', placeholder: 'e.g. "Neglect", "LAC Review", "Section 47"' },
      {
        key: 'emotional_safety',
        render: (editing, setEditing, testIdPrefix) => (
          <SafetyFieldset editing={editing} setEditing={setEditing} testIdPrefix={testIdPrefix} />
        ),
      },
    ]}
  />
);

export default AdminLibraryTags;
